import Box from '@mui/material/Box'
import { ChangeEvent, FocusEventHandler, memo } from 'react'
import Checkbox from '@mui/material/Checkbox'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

const CheckboxButtonContainerOption = <T extends string>({
  value,
  checked,
  label,
  tooltip,
  onChange,
  onBlur,
  disabled,
}: {
  value: T
  checked: boolean
  label: string
  tooltip?: string
  onChange?: (eventOrValue: ChangeEvent<HTMLInputElement>, checked: boolean) => void
  onBlur?: FocusEventHandler<HTMLButtonElement>
  disabled?: boolean
}) => {
  return (
    <Box
      component="label"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        cursor: 'pointer',
        position: 'relative',
        paddingRight: 4,
      }}
    >
      <Box>
        <Checkbox
          size="small"
          value={value}
          checked={!!checked}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          sx={{
            '&:hover': {
              backgroundColor: 'transparent',
            },
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography
          component={'span'}
          variant="subtitle2"
          sx={{ fontSize: 12, lineHeight: '12px' }}
        >
          {label}
        </Typography>
      </Box>
      {tooltip && (
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            right: 0,
            transform: 'translate(-50%, -50%)',
            display: 'flex',
          }}
        >
          <Tooltip title={tooltip} enterTouchDelay={0} placement="top">
            <InfoOutlinedIcon
              color="primary"
              sx={{ fontSize: 16, backgroundColor: 'white', borderRadius: '50%' }}
            />
          </Tooltip>
        </Box>
      )}
    </Box>
  )
}

export default memo(CheckboxButtonContainerOption)
